import { motion } from 'framer-motion';

function ReUsableHeaderTitle({ title, desc }) {
  const rightVariant = {
    offscreen: { x: -50, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.3, duration: 1.2 },
    },
  };

  const rightVariantP = {
    offscreen: { x: -50, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.3, duration: 1.4 },
    },
  };

  return (
    <div className="w-75">
      <motion.h1
        variants={rightVariant}
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true }}
        className="fs-1 fw-bold"
      >
        {title}
      </motion.h1>
      <motion.p
        variants={rightVariantP}
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true }}
        className="mt-4 m-0 fw-light text-muted"
      >
        {desc}
      </motion.p>
    </div>
  );
}

export default ReUsableHeaderTitle;
